import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import {
  AfterContentInit,
  ChangeDetectorRef,
  EventEmitter,
  Injectable,
  Injector,
  Input,
  OnInit,
  Optional,
  Output
} from '@angular/core';
import { Subscription } from 'rxjs';

export type CustomFormControl = FormControl & { markRequired?: boolean };

@Injectable()
export abstract class Wrapper implements ControlValueAccessor, OnInit, AfterContentInit {

  private _value: any;
  private _subscription: Subscription;
  protected cdr: ChangeDetectorRef;

  public formControl: CustomFormControl;
  public ngControl: NgControl;

  @Input() label: string = '';
  @Input() tooltip: string = '';

  @Input() required?: boolean = false;
  @Output() change = new EventEmitter<any>();

  constructor(@Optional() public injector: Injector) {
    this.cdr = injector.get(ChangeDetectorRef);
  }

  setDisabledState(disable: boolean) {
    if (this.formControl.disabled === disable) {
      return;
    }

    if (disable) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  ngOnInit(): void {
    this.updateFormControl();
  }

  ngAfterContentInit(): void {
    this.cdr.detectChanges();
  }

  updateFormControl() {
    this.ngControl = this.injector.get(NgControl);

    // sima FormControl
    const formDirective = (this.ngControl as any).formDirective;
    const newFormControl = formDirective?.form?.get(this.ngControl.name);

    // ha nem változott a control, akkor nem kell folytatni
    if (newFormControl && newFormControl === this.formControl) {
      return;
    }

    this.formControl = newFormControl;

    // ha már lenne subscription akkor töröljük, hogy ne eredményezzen hibás állapotot
    this._subscription?.unsubscribe();

    // ngModel support
    if (!this.formControl) {
      this.formControl = this.ngControl.control as FormControl;

      // új subscription
      this._subscription = this.ngControl.valueChanges.subscribe(value => {
        if (value !== this._value) {
          this._value = value;
          this.onChange(value);
          this.change.emit(value);
        }
      });
    } else {
      this._subscription = this.formControl.valueChanges.subscribe(value => {
        this.change.emit(value);
      });
    }
  }

  onChange: (_: any) => void = (_: any) => {};
  onTouched: () => void = () => {};

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.updateFormControl();
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
